import { Injectable } from '@angular/core';
import { LoggerService } from 'src/app/services/logger.service'
import { Store } from "@ngxs/store";
import { UuidAndId } from '../state-man/models/uuid-and-id';
import { UiService } from './ui.service';
import { StoreActions } from '../state-man/actions/store.actions';
import { User } from '../state-man/models/user.model';
import { CallService } from './call.service';
import { CallActions } from '../state-man/actions/call.actions';
import { Call } from '../state-man/models/call.model';
import { ConfigActions } from '../state-man/actions/config.actions';
import { ProjectActions } from '../state-man/actions/project.actions';
import {Photo} from "../state-man/models/photo.model";

@Injectable({
  providedIn: 'root'
})
export class OfflineService {  
  is_processing_calls = false
  
  constructor(        
    private callEntryService: CallService,
    private store: Store,
    private uiService: UiService    
    ) {}

  async processPendingCalls(callEntries: Call[]) {
    try {
      if (!this.is_processing_calls) {
        this.is_processing_calls = true
        await this.uploadPendingCallDeletes(callEntries)
        await this.uploadPendingCallSaves(callEntries)
        this.is_processing_calls = false
      }
    } catch(e) {
      LoggerService.log(e)
      this.is_processing_calls = false
    }
  };

  async uploadCallPhoto(call: Call, photo: Photo) {
    try {
      if ( call.id && !photo.uploaded ) {
        let apiPhoto;
        try {
          const callAndPhotoCurrent = { call_id: call.id, photo: photo };
          this.store.dispatch(new CallActions.ApiStartUploading(callAndPhotoCurrent));
          apiPhoto = await this.callEntryService.addPhoto(call, photo);
          this.store.dispatch(new CallActions.ApiStopUploading(callAndPhotoCurrent));
        }
        catch (error) {
          const callAndPhotoCurrent = { call_id: call.id, photo: photo };
          this.store.dispatch(new CallActions.ApiStopUploading(callAndPhotoCurrent));
          throw error;
        }
        let addedPhoto = await Photo.buildOne(apiPhoto);
        addedPhoto.uuid = photo.uuid;
        addedPhoto.file_name = photo.file_name;
        addedPhoto.file_type = photo.file_type;
        addedPhoto.uploaded = true;
        const callAndPhoto = { call_id: call.id, photo: addedPhoto };
        this.store.dispatch(new CallActions.ApiAddedPhotoToCall(callAndPhoto));
      }
    }
    catch (error) {
      LoggerService.log(error);
    }
  }
  
  async uploadPendingCallSaves(callEntries: Call[]) {
    try {              
        for (const callEntry of callEntries) {
          if (callEntry.is_pending_save) {
            if (callEntry.id <= 0) {
              const apiObj = await this.callEntryService.addCall(callEntry)
              if (apiObj) {
                const id: number = apiObj.id
                const uuid: string = callEntry.uuid
                const payload: Call = Call.buildOne({...apiObj, uuid, id})
                this.store.dispatch(new CallActions.ApiAddedOne(payload))
                for (const photo of callEntry.photos) {
                  await this.uploadCallPhoto(payload, photo);
                }
              } 
            } else {
              const apiObj = await this.callEntryService.updateCall(callEntry)
              if (apiObj) {
                const id: number = apiObj.id
                const uuid: string = callEntry.uuid
                const payload: Call = Call.buildOne({...apiObj, uuid, id})
                this.store.dispatch(new CallActions.ApiUpdatedOne(payload))
                for (const photo of callEntry.photos) {
                  await this.uploadCallPhoto(payload, photo);
                }
              }
            }
          } else {
            if (callEntry.photos && callEntry.photos.length > 0) {
              for (const photo of callEntry.photos) {
                await this.uploadCallPhoto(callEntry, photo);
              }
            }
          }
        }                    
    } catch (error) {            
      LoggerService.log(error)
    } 
  }

  async uploadPendingCallPhotoDeletes(call: Call) {
    if (call.deleted_photos && call.deleted_photos.length > 0) {
      try {
        for(const photo of call.deleted_photos) {
          if (photo.id) {
            const callAndPhotoCurrent = { call_id: call.id, photo: photo };
            await this.callEntryService.deletePhoto(callAndPhotoCurrent);
            this.store.dispatch(new CallActions.ApiDeletedPhotoFromCall(callAndPhotoCurrent));
          }
        }
      }
      catch (error) {
        LoggerService.log(error);
      }
    }
  }

  async uploadPendingCallDeletes(callEntries: Call[]) {
    try {              
        for (const callEntry of callEntries) {
          if (callEntry.is_pending_delete) {
            const status = await this.callEntryService.deleteCall(callEntry)
            if (status && status === 'OK') {
              const id: number = callEntry.id
              const uuid: string = callEntry.uuid
              const payload: UuidAndId = {uuid, id}                   
              this.store.dispatch(new CallActions.ApiDeletedOne(payload))
            }             
          }
          await this.uploadPendingCallPhotoDeletes(callEntry);
        }                    
    } catch (error) {            
      LoggerService.log(error)   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')    
    } 
  }
 
  async refresh(user: User) {
    try {            
      this.store.dispatch(new ConfigActions.Refresh())                
      this.store.dispatch(new StoreActions.Refresh(user))
      this.store.dispatch(new CallActions.Refresh())
      this.store.dispatch(new ProjectActions.Refresh())

      // Do this to trigger uploading pending data
      await this.trigger_pending()
      //this.uiService.stopWait()
    } catch (e) {
      //this.uiService.stopWait()
      LoggerService.log(e)
    }  
  }  

  async trigger_pending() {
    try {
      // Do this to trigger uploading pending data
      this.store.dispatch(new CallActions.IncrementPendingCount())
    } catch (e) {
      LoggerService.log(e)
    }  
  }  

}
